import { render, staticRenderFns } from "./ShoppingCartTotals.vue?vue&type=template&id=a81a2d82"
import script from "./ShoppingCartTotals.vue?vue&type=script&lang=js"
export * from "./ShoppingCartTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports